import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Testimonials() {
  const {
    t
  } = useLanguage();
  const [featured, ...rest] = t.testimonials.items;
  return <section id="testimonios" className="w-full bg-panelAlt py-20 lg:py-28" data-id="element-290" data-mp="3fy30dz1cpy53">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-291" data-mp="3azje1xiuikc7">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between" data-id="element-292" data-mp="36yzgisud1epj">
          <div className="max-w-2xl" data-id="element-293" data-mp="36wmr5um9w22g">
            <p className="mb-4 text-xs uppercase tracking-[0.28em] text-gold" data-id="element-294" data-mp="31zmqy0c3ttj9">
              {t.testimonials.eyebrow}
            </p>
            <h2 className="font-display text-3xl font-bold uppercase leading-tight text-cream sm:text-4xl lg:text-[2.9rem]" data-id="element-295" data-mp="2x11tu9s5fpz1">
              {t.testimonials.title}
            </h2>
          </div>
          <div className="flex items-center gap-2" aria-label={t.testimonials.ratingLabel} data-id="element-296" data-mp="v8wvogk23wfv">
            {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-5 w-5 fill-gold text-gold" aria-hidden="true" data-id="element-297" data-mp="h5y7wcgvp92k" />)}
            <span className="ml-1 text-sm text-cream/70" data-id="element-298" data-mp="m4rnqbjn1c5w">5.0</span>
          </div>
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-[1.15fr_0.85fr]" data-id="element-299" data-mp="780jnoz0rc9y">
          <figure className="flex flex-col rounded-sm border border-gold/30 bg-ink p-8 lg:p-11" data-id="element-300" data-mp="79v8hedevojb">
            <QuoteIcon className="h-9 w-9 text-gold" aria-hidden="true" data-id="element-301" data-mp="c8y282nxy8bz" />
            <blockquote className="mt-6 font-display text-2xl font-medium leading-snug text-cream lg:text-3xl" data-id="element-302" data-mp="zxr38djf76dg">
              “{featured.quote}”
            </blockquote>
            <figcaption className="mt-auto pt-8 text-sm" data-id="element-303" data-mp="q7eiolblvd7b">
              <span className="block font-semibold text-gold-light" data-id="element-304" data-mp="q4sbwnwjh1q5">{featured.name}</span>
              <span className="block text-cream/60" data-id="element-305" data-mp="v3mrzi34gc6k">{featured.role}</span>
            </figcaption>
          </figure>

          <div className="grid gap-6" data-id="element-306" data-mp="1ith6s5704atg">
            {rest.map(testimonial => <figure key={testimonial.name} className="flex flex-col rounded-sm border border-white/10 bg-ink p-6" data-id="element-307" data-mp="1no3g82tivtaw">
                <blockquote className="text-sm leading-relaxed text-cream/80" data-id="element-308" data-mp="1sjz32m08rqll">
                  “{testimonial.quote}”
                </blockquote>
                <figcaption className="mt-auto pt-5 text-xs" data-id="element-309" data-mp="1oj5erriw09s6">
                  <span className="block font-semibold text-gold-light" data-id="element-310" data-mp="1jhpva3wcybbw">{testimonial.name}</span>
                  <span className="block text-cream/55" data-id="element-311" data-mp="1ekpplu3f7alb">{testimonial.role}</span>
                </figcaption>
              </figure>)}
          </div>
        </div>
      </div>
    </section>;
}